import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";

export default function CancelPage() {
  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-5"
      style={{ backgroundColor: "#E8E6F5" }}
      data-testid="cancel-page"
    >
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center">
          <XCircle className="w-10 h-10 text-slate-700" strokeWidth={2} />
        </div>
        <h1 className="font-heading text-2xl font-extrabold text-slate-900 mt-5">
          Donation cancelled
        </h1>
        <p className="text-slate-500 mt-2">
          No charge was made. You can try again whenever you're ready.
        </p>
        <Link
          to="/"
          data-testid="back-to-donate"
          className="mt-7 inline-flex items-center gap-2 px-5 py-3 bg-[#0F172A] hover:bg-[#1E293B] text-white font-semibold rounded-xl transition-all"
        >
          <ArrowLeft className="w-4 h-4" /> Back to donate
        </Link>
      </div>
    </div>
  );
}
